module.exports = __webpack_public_path__ + "img/book_anquan.cbf03aa5.png";